var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeypadInvertv2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 36,
    viewBox: "0 0 25 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.65857,
    y: 2.24939,
    width: 21.3011,
    height: 32.1694,
    rx: 4.5,
    fill: "white",
    stroke: "black",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.78278,
    y: 7.46729,
    width: 5.05256,
    height: 2.3056,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4281 7.46729H19.3955C19.9478 7.46729 20.3955 7.915 20.3955 8.46729V8.77289C20.3955 9.32517 19.9478 9.77289 19.3955 9.77289H16.4281V7.46729Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.22278 8.46729C4.22278 7.915 4.67049 7.46729 5.22278 7.46729H8.19015V9.77289H5.22278C4.67049 9.77289 4.22278 9.32517 4.22278 8.77289V8.46729Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeypadInvertv2);
export default __webpack_public_path__ + "static/media/KeypadInvertv2.1bf0910d9cd77868f095a38cdc452648.svg";
export { ForwardRef as ReactComponent };